import { Component, OnInit, Input, input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { SaComponent } from 'smartauction-frontend-micro-library';

@Component({
  selector: 'app-active-vehicles-count',
  templateUrl: './active-vehicles-count.component.html',
  styleUrls: ['./active-vehicles-count.component.scss'],
  imports: [DecimalPipe]
})
export class ActiveVehiclesCountComponent extends SaComponent {
  count = input<number>(0);
  resultText = input<string>('');
}
